import { useEffect, useRef } from 'react'

import { useTranslation } from 'react-i18next'
import { useNavigate, useSearchParams } from 'react-router-dom'

import { addToast } from 'components/Toast/Toast'
import { useLoadingContext } from 'context/loadingContext'
import { googleCallback } from 'services/endpoints/auth'
import { useSetAccessToken, useSetUserProfile } from 'store'
import { type GoogleCallbackPayload } from 'types/api/auth'
import { useLocalStorageSetAccessToken } from 'utils'

export const GoogleCallback = () => {
    const { handleGlobalLoading } = useLoadingContext()
    const [searchParams] = useSearchParams()
    const navigate = useNavigate()
    const { t } = useTranslation()
    const handledCallback = useRef(false)

    const googleErrorFn = () => {
        addToast('error', t('error:anErrorOccuredPleaseTryAgain'), 7000, true)
    }

    const checkQueryParams = async (queryParams: GoogleCallbackPayload) => {
        if (!queryParams?.code) {
            handleGlobalLoading(false)
            googleErrorFn()
            return
        }

        try {
            const { token, userProfile } = await googleCallback(queryParams)

            if (!token || !userProfile) {
                throw new Error('Google callback response is missing authentication data')
            }

            useSetUserProfile(userProfile)
            useSetAccessToken(token)
            useLocalStorageSetAccessToken(token)

            handleGlobalLoading(false)

            navigate('/', {
                replace: true
            })
        } catch (err) {
            handleGlobalLoading(false)
            googleErrorFn()
        }
    }

    useEffect(() => {
        if (handledCallback.current) return

        handledCallback.current = true

        const queryParams = Object.fromEntries(
            searchParams
        ) as unknown as GoogleCallbackPayload

        handleGlobalLoading(true)

        void checkQueryParams(queryParams)
    }, [])

    return null
}